import { Component, OnInit, Input, HostBinding } from '@angular/core';

import { CalendarState } from '../../lib/calendar-state';
import { CalendarDay } from '../../lib/calendar-day';

@Component({
  selector: 'pg-calendar-grid-cell, grit-calendar-grid-cell',
  templateUrl: './pg-calendar-grid-cell.component.html',
  styleUrls: ['./pg-calendar-grid-cell.component.scss'],
  exportAs: 'gritCalendarGridCell',
})
export class PgCalendarGridCellComponent implements OnInit {
  @Input()
  size;

  @HostBinding('style.width')
  @HostBinding('style.height')
  get _styleSize() {
    return this.size + 'px';
  }

  @Input()
  @HostBinding('style.color')
  color = 'black';

  @HostBinding('class.out-of-month')
  get outOfMonth() {
    return this.day.monthRelativePosition !== 'CURRENT';
  }

  @HostBinding('class.out-of-range')
  get outOfRange() {
    return this.day.outOfRange;
  }

  @Input()
  day: CalendarDay;

  constructor() {}

  ngOnInit() {}
}
